import React from 'react';

import { getSubdomain, isSaaSSubdomain } from 'utils/getSubdomain';
import SaaSHeader from './SaaSHeader';
import Header from './Header';

const HorizontalHeader = () => {
  return isSaaSSubdomain() ? <SaaSHeader /> : <Header />;
};

export default HorizontalHeader;
